export default __webpack_public_path__ + "static/media/equal-logo.277d7fbb.svg";